export default __webpack_public_path__ + "static/media/user_report.7c7fc54e.png";